/*
 * Application Insights JavaScript SDK - Core, 2.8.4
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


export var strIKey = "iKey";
export var strExtensionConfig = "extensionConfig";
//# sourceMappingURL=Constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@microsoft/applicationinsights-core-js/dist-esm/JavaScriptSDK/Constants.js
// module id = 116
// module chunks = 0